export { default as InvoiceItemsViewTableBody } from './InvoiceItemsViewTableBody';
